<template>
	<label class="label">
		<template v-if="tooltip">
			<v-tooltip top>
				<span slot="activator">
					{{ label | limitTo(limitToFilter) }}
				</span>
				<span>{{ label }}</span>
			</v-tooltip>
		</template>
		<template v-else>
			{{ label }}
		</template>
		<v-text-field
			hide-details
			v-bind="$attrs"
			class="filter-select shadow-inset"
			:class="{ 'show-error': errorClass, 'textarea-custom': textareaClass }"
			:style="`max-width: ${maxWidth}px`"
			:placeholder="newPlaceholder"
			:value="text"
			@input="handleInput"
			@keyup.enter="sendValueEnter"
			@keyup.exact="showError"
			@change="onChange"
			@blur="onBlur"
		></v-text-field>
		<template v-if="tooltipOnFocused">
			<div class="tooltip-on-focused">
				{{ tooltipMessage }}
			</div>
		</template>
	</label>
</template>

<script>
import helper from '@/shared/helper';

const { debounce } = helper;

function mounted() {
	if (this.googleMap && this.$attrs.id) {
		const input = document.getElementById(this.$attrs.id);
		const autocomplete = new window.google.maps.places.Autocomplete(
			input,
			{
				types: ['geocode'],
			},
		);
		autocomplete.addListener('place_changed', () => {
			const place = autocomplete.getPlace();
			this.$emit('input-map', place);
		});
	}
}

function newPlaceholder() {
	return this.placeholder || this.label;
}

function onChange(value) {
	this.$emit('change', value);
}

function onBlur(value) {
	this.$emit('blur', value);
}

function sendValue(value) {
	const onSearch = this.searcher && this.model === 'search';
	const body = { value, model: this.model, onSearch };
	this.$emit('input', body);
}

function sendValueNumber(value) {
	const onSearch = this.searcher && this.model === 'search';
	const body = { value, model: this.model, onSearch };
	this.$emit('input', body);
}

function checkAndSend(value) {
	const trimmedValue = value.trim();
	const parsedValue = parseFloat(trimmedValue);
	if (!isNaN(parsedValue) && /^-?\d*\.?\d+$/.test(trimmedValue)) {
		this.sendValueNumber(trimmedValue);
	} else {
		this.sendValue(trimmedValue);
	}
}

function handleInput(value) {
	if (!this.debouncedHandleInput) {
		this.debouncedHandleInput = debounce(this.checkAndSend, 800);
	}
	this.debouncedHandleInput(value);
}

function sendValueEnter(event) {
	this.$emit('input-enter', event);
}

function showError(value) {
	this.$emit('show-error', value);
}

export default {
	name: 'app-input-text',
	computed: {
		newPlaceholder,
	},
	inheritAttrs: false,
	methods: {
		onBlur,
		onChange,
		sendValue,
		sendValueEnter,
		showError,
		sendValueNumber,
		checkAndSend,
		handleInput,
	},
	mounted,
	props: {
		errorClass: {
			default: false,
			type: Boolean,
		},
		googleMap: {
			type: Boolean,
			default: false,
		},
		label: String,
		limitToFilter: [Number, String],
		maxWidth: Number,
		model: String,
		placeholder: String,
		searcher: {
			default: false,
			type: Boolean,
		},
		text: [Number, String],
		textareaClass: {
			type: Boolean,
			default: false,
		},
		tooltip: [String, Number],
		tooltipMessage: String,
		tooltipOnFocused: {
			default: false,
			type: Boolean,
		},
	},
};
</script>

<style lang="scss" scoped>
.label {
	font-size: size(small);
	position: relative;
}

.text-field {
	border: 1px solid rgba(0, 0, 0, 0.1);
	border-radius: 3px;
	padding: 0 16px;
}

.tooltip-on-focused {
    background: rgba(36, 36, 36, .9);
    border-radius: 5px;
    bottom: 0;
	color: white;
	display: none;
    font-family: 'AvenirRegular';
    font-size: 12px;
    height: 44px;
    left: -250px;
    margin: auto;
    padding: 5px;
	position: absolute;
    text-align: center;
    top: 35px;
    width: 250px;
}
</style>



// WEBPACK FOOTER //
// src/components/autocomplete/app-input-text.vue